import { createApiCall } from 'lib/base';

const LIST_WEALTH_PROGRAM_FEES = 'WEALTH/LIST_WEALTH_PROGRAM_FEES';

const apiCall = createApiCall(
  LIST_WEALTH_PROGRAM_FEES,
  ({ id }: { id: string }) => ({
    endpoint: `/api/admin/wealth/programs/${id}/fees`,
    method: 'GET',
  })
);

export default apiCall;
